import type { AIProviderName } from '../types';

/**
 * Window-global names where decrypted/plaintext API keys live during a session.
 * settings.ts writes these on save/restore; client.ts reads them for the BYOK
 * fallback chain. Single source of truth — do not redefine.
 */
export const PROVIDER_WIN_KEYS: Record<AIProviderName, string> = {
  gemini: 'GEMINI_API_KEY',
  groq: 'GROQ_API_KEY',
  openai: 'OPENAI_API_KEY',
  claude: 'CLAUDE_API_KEY',
  volcengine: 'VOLCENGINE_API_KEY',
};
